import {Layout} from '../../../layout'
import {EitjeVirtuoso} from '../../../eitje_virtuoso'
import {usePageContext} from '../../../page_layout/page_context'
import {BasicTableRow} from '../row'
import {useBasicTableContext} from '../../context'
import {EndOfContentPlaceholder} from './end_of_content_placeholder'
import {Placeholder} from './placeholder'
import './index.less'

const sharedProps = {
	className: 'basic-table-body',
	direction: 'vertical',
	width: 'full',
	gap: 0,
	borderLeft: true,
	borderRight: true,
	borderBottom: true,
	grow: true,
	style: {
		alignItems: 'unset',
		borderRadius: '0 0 4px 4px',
	},
}

export const BasicTableBody = () => {
	const {floating} = usePageContext()

	const {data, hasData, columns, endOfContentPlaceholder, virtual, customScrollParent, hideHeader} = useBasicTableContext()

	if (!hasData) {
		const hideHeaderProps = hideHeader ? {borderTop: true, borderRadius: true} : {}
		return (
			<Layout {...sharedProps} {...hideHeaderProps}>
				<Placeholder />
			</Layout>
		)
	}

	const renderRow = (index, item) => {
		return <BasicTableRow key={item.customId || item.idWithTableName?.() || item.id} item={item} columns={columns} index={index} />
	}

	if (!virtual) {
		return (
			<Layout {...sharedProps}>
				{data.map((item, index) => renderRow(index, item))}
				{endOfContentPlaceholder && <EndOfContentPlaceholder />}
			</Layout>
		)
	}

	const virtuosoProps = (floating || customScrollParent) && {
		...(floating && {useWindowScroll: true}),
		customScrollParent: customScrollParent || '.page-layout',
	}

	return (
		<Layout {...sharedProps}>
			<EitjeVirtuoso
				data={data}
				components={{Footer: endOfContentPlaceholder && EndOfContentPlaceholder}}
				itemContent={renderRow}
				{...virtuosoProps}
			/>
		</Layout>
	)
}
